import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { X } from 'lucide-react';
interface ResultReadyBannerProps {
  show: boolean;
  hasFullAccess: boolean;
}
const EASE = [0.23, 1, 0.32, 1] as const;

/** Quiet confirmation that a freshly finished analysis is on screen. */
export function ResultReadyBanner({
  show,
  hasFullAccess
}: ResultReadyBannerProps) {
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  const visible = show && !dismissed;
  return <AnimatePresence data-id="element-400" data-mp="1kajr3gtk07vt">
      {visible && <motion.div role="status" aria-live="polite" initial={reduceMotion ? false : {
      opacity: 0,
      y: -6
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -6
    }} transition={{
      duration: 0.22,
      ease: EASE
    }} className="flex items-center gap-3 rounded-xl border border-emerald-400/25 bg-emerald-400/[0.06] py-3 pl-4 pr-2" data-id="element-401" data-mp="1fa4h8z8hdiil">
          <svg viewBox="0 0 24 24" className="h-7 w-7 shrink-0" fill="none" aria-hidden="true" data-id="element-402" data-mp="1mzwa4qt8tklp">
            <circle cx="12" cy="12" r="11" className="fill-emerald-400/15" data-id="element-403" data-mp="1rxehicrm3rrl" />
            <motion.path d="M7.5 12.5l3 3 6-6.5" className="stroke-emerald-300" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" initial={reduceMotion ? false : {
          pathLength: 0
        }} animate={{
          pathLength: 1
        }} transition={{
          duration: 0.28,
          delay: 0.12,
          ease: EASE
        }} data-id="element-404" data-mp="1dz6dxm02ls7g" />
          </svg>
          <div className="min-w-0 flex-1" data-id="element-405" data-mp="u9nm4ic105z7">
            <p className="text-sm font-semibold text-white" data-id="element-406" data-mp="zaaa6151r1cn">Your analysis is ready</p>
            <p className="mt-0.5 text-xs leading-relaxed text-forensic-muted" data-id="element-407" data-mp="lbal4sdmgkfy">
              {hasFullAccess ? 'Start with your score, then explore the evidence behind each pattern.' : 'Your score and detected patterns are below. Unlock the full report to see the evidence.'}
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss" className="rounded-lg p-2 text-forensic-subtle transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300" data-id="element-408" data-mp="2n7sw7r8fn0cp">
            <X size={15} data-id="element-409" data-mp="3axdox1ue1bz6" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}